<template>
    <v-dialog v-model="getAddFaq" width="55%" height="55%" persistent>
        <v-card>
            <v-card-title>Add Faq </v-card-title>
            <v-divider></v-divider>
            <v-row no-gutters class="mx-5 mt-5">
                <v-col cols="3">
                    <v-text-field label="Link ID" outlined disabled v-model="faqDetails.linkID"
                        class="mx-2"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-select :items="getFaqCategory" item-text="categoryName" item-value="categoryName"
                        v-model="faqDetails.category" label="Category" class="mx-2"></v-select>
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-5">
                <v-col cols="4">
                    <v-textarea v-model="faqDetails.question" label="Question" class="ma-2 mr-4" outlined></v-textarea>
                </v-col>
                <v-col cols="8">
                    <v-textarea v-model="faqDetails.answer" label="Answer" class="ma-2 ml-4" outlined></v-textarea>
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-5">
                <v-col cols="2">
                    <v-switch v-model="faqDetails.showMap" label="Show Map" class="mx-2"></v-switch>
                </v-col>
                <v-col cols="4">
                    <v-select :items="getMaps" item-text="mapName" item-value="mapName" v-model="faqDetails.mapName"
                        label="Map Name" outlined :disabled="!faqDetails.showMap"></v-select>
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-5">
                <v-col cols="2">
                    <v-switch v-model="faqDetails.showform" label="Show Form" class="mx-2"></v-switch>
                </v-col>
                <v-col cols="4">
                    <v-text-field v-model="faqDetails.formName" label="Form Name" outlined
                        :disabled="!faqDetails.showform"></v-text-field>
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-5">
                <v-col cols="2">
                    <v-switch v-model="faqDetails.showQr" label="Show QR" class="mx-2"></v-switch>
                </v-col>
                <v-col cols="4">
                    <v-textarea v-model="faqDetails.qrDetails" label="QR Code info" outlined
                        :disabled="!faqDetails.showQr"></v-textarea>
                </v-col>
                <v-col cols="4" class="ml-4">
                    Ex. <br>
                    <span>{"qrlist":[ { "name": "Button Name", "link":"Link to website"}]}</span>
                </v-col>
            </v-row>
            <v-card-actions class="justify-end">
                <v-btn width="100" class="ma-3" color="primary" @click="addFaq()"><v-icon class="mr-2"
                        small>mdi-plus</v-icon>Add</v-btn>
                <v-btn width="100" class="ma-3" @click="closeFaq()" color="grey"><v-icon class="mr-2"
                        small>mdi-close</v-icon> Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: "viewFaqs",
    data() {
        return {
            faqDetails: {
                isNew: false,
                question: '',
                answer: '',
                category: '',
                showMap: false,
                mapName: '',
                showform: false,
                formName: '',
                showQr: false,
                qrDetails: "",
                linkID: 0
            }
        }
    },
    computed: {
        ...mapGetters(['getAddFaq', 'getFaqCategory', 'getMaps', 'getFaqs', 'snackBar'])
    },
    watch: {
        getAddFaq(newVal) {
            if (newVal) {
                let tempFaqs = this.getFaqs.sort((a, b) => { return a.linkID - b.linkID })
                console.log('Temp faqs: ', tempFaqs[tempFaqs.length - 1])
                this.faqDetails.linkID = tempFaqs[tempFaqs.length - 1].linkID + 1
            }
        },
        snackBar(newVal) {
            if (newVal.show) {
                this.closeFaq();
            }
        }
    },
    methods: {
        closeFaq() {
            this.faqDetails = {
                isNew: false,
                question: '',
                answer: '',
                category: '',
                showMap: false,
                mapName: '',
                showform: false,
                formName: '',
                showQr: false,
                qrDetails: '',
                linkID: 0
            }
            this.$store.commit('setAddFaq', false);
        },
        addFaq() {
            console.log('New Faq: ', this.faqDetails)
            if (this.faqDetails.qrDetails === "") {
                this.faqDetails.qrDetails = {}
            } else {
                delete this.faqDetails.qrDetails;
            }
            this.$store.dispatch('createIndex', this.faqDetails)
        }
    },
}
</script>